import { Group, useMantineTheme } from '@mantine/core';
import type { PolicyOut } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { FrameworkSelector } from '../../../PoliciesPage/components/FrameworkSelector';
import { InlineFrameworkPill } from './InlineFrameworkPill';
import { INLINE_TEXT_HEIGHT, INLINE_TEXT_WIDTH } from './constants';

export interface InlineFrameworkProps {
	policy: PolicyOut;
	readOnly?: boolean;
}

export default function InlineFramework({
	policy,
	readOnly = false,
}: InlineFrameworkProps) {
	const theme = useMantineTheme();
	return (
		<Group spacing="xs" noWrap align="flex-start">
			<Text
				w={INLINE_TEXT_WIDTH}
				style={{ lineHeight: `${INLINE_TEXT_HEIGHT}px` }}
				size="sm"
				color="text/secondary/default"
			>
				Frameworks
			</Text>
			{policy.frameworks && policy.frameworks.length > 0 ? (
				<Group
					spacing="xs"
					pl="sm"
					sx={{
						maxWidth: `calc(100% - ${INLINE_TEXT_WIDTH}px - ${theme.spacing.sm})`, // width accounts for title + padding
					}}
				>
					{policy.frameworks?.map((framework) => (
						<InlineFrameworkPill
							key={framework}
							policy={policy}
							framework={framework}
							readOnly={readOnly}
						/>
					))}
					<FrameworkSelector iconOnly policy={policy} readOnly={readOnly} />
				</Group>
			) : (
				<FrameworkSelector
					hideOnEmpty={false}
					policy={policy}
					placeholder="Add framework"
					placeholderIconName="plus"
					readOnly={readOnly}
				/>
			)}
		</Group>
	);
}
